module.exports = __webpack_public_path__ + "static/img/1en.bdadd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/1en.png
// module id = erzc
// module chunks = 0